


















































































import { Component, Vue } from "vue-property-decorator";
import { copyUser } from "@/services/users/usersService";
import { CopyUser } from "@/services/users/types";
import { detailsValidators } from "@/components/users/validators";
import validate from "@/directives/validate";
import { validateForm } from "@/services/validation/validationService";
import { ValidationModel, ValidationType } from "@/services/validation/types";

@Component({
    directives: {
        validate
    }
})
export default class UserCopyModal extends Vue {
    model = {} as CopyUser;
    validators = {
        firstName: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 3 }
            ]
        } as ValidationModel,
        lastName: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 3 }
            ]
        } as ValidationModel,
        email: {
            rules: [
                { type: ValidationType.Required },
                { type: ValidationType.Min, value: 3 },
                { type: ValidationType.UniqueEmail }
            ]
        } as ValidationModel
    };

    name = ""

    open(id: string, name: string) {
        this.model.userToCopyId = id;
        this.name = name;
        this.$bvModal.show("modal-copy");
    }

    async confirm() {
        if (!await validateForm([this.validators])) return;
        this.$bvModal.hide("modal-copy");
        copyUser(this.model).then(() => {
            this.$emit("reload");
        });
    }

    decline() {
        this.$bvModal.hide("modal-copy");
    }

    resetState() {
        this.model = {} as CopyUser;
    }
}
